import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    content: {
        transform: "unset !important",
        [theme.fn.largerThan("xs")]: {
            borderRadius: "1rem",
        },

        [`@media (max-height: 767px)`]: {
            height: "100vh",
            maxHeight: "none",
        },
    },
    form: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    wrapper: {
        padding: "1rem 1.5rem",
        paddingBottom: "calc(40px + 2rem)",
        [theme.fn.largerThan("xs")]: {
            borderRadius: "1rem",
            padding: "2rem",
        },

        [theme.fn.largerThan("lg")]: {
            maxWidth: rem(1120),
        },

        "& .mantine-InputWrapper-root": {
            maxHeight: "initial",
        },
    },
    header: {
        display: "flex",
        flexDirection: "column",
        [theme.fn.largerThan("xs")]: {
            alignItems: "flex-start",
            padding: "0",
        },
        gap: "2rem",
        width: "100%",
        [theme.fn.smallerThan("sm")]: {
            padding: "3rem 0 0 0",
        },
        marginBottom: ".5rem",
    },
    title: {
        fontWeight: 500,
        fontSize: rem(24),
        color: theme.colors.gray[9],
        margin: 0,
        lineHeight: "2rem",
    },
    body: {
        display: "flex",
        gap: "1.5rem",
        border: 0,
        padding: 0,
        color: theme.colors.gray[7],
        marginBottom: "1rem",
    },
    actions: {
        display: "flex",
        justifyContent: "flex-end",
        padding: "1rem 1.5rem",
        position: "fixed",
        bottom: 0,
        width: "100%",

        boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.1)",
        backgroundColor: "white",

        [theme.fn.largerThan("xs")]: {
            boxShadow: "none",
            padding: "0 2rem 1rem 2rem",
            position: "absolute",
            bottom: 0,
            left: 0,
        },
        button: {
            backgroundColor: theme.colors.violet[7],
            "&:hover": {
                backgroundColor: theme.colors.violet[9],
            },
            "&:focus": {
                backgroundColor: theme.colors.violet[9],
                boxShadow: `0px 0px 0px 2px ${theme.colors.violet[5]}`,
            },
            "&:active": {
                boxShadow: `0px 0px 0px 2px ${theme.colors.violet[5]}`,
            },
            "&[aria-disabled]": {
                backgroundColor: theme.colors.violet[1],
                color: theme.colors.violet[3],
            },
        },
    },
    section: {
        gap: "1rem",

        [theme.fn.largerThan("xs")]: {
            gap: "1.5rem",
        },
    },
    radioGroup: {
        paddingBottom: "40px",

        "& .mantine-RadioGroup-label": {
            fontSize: rem(18),
            color: theme.colors.gray[7],
            marginBottom: "1rem",
        },
    },
    options: {
        flex: 1,
        gap: "0.5rem",

        [theme.fn.largerThan("xs")]: {
            overflowY: "visible",
        },
    },
    option: {
        paddingLeft: "1rem",
        borderRadius: ".5rem",
        padding: "0.2rem 0.5 rem",
        transition: ".3s ease-in-out",
        transitionProperty: "border background-color color",

        "&[data-checked]": {
            border: `1px solid ${theme.colors.violet[5]}`,
            backgroundColor: theme.colors.violet[1],

            "& .mantine-Radio-icon": {
                color: theme.colors.violet[7],
            },
        },

        "& .mantine-Radio-labelWrapper": {
            flex: "1",
        },

        "& .mantine-Radio-label": {
            padding: "0.5rem",
        },

        "& .mantine-Group-root": {
            gap: "0.25rem",
            marginLeft: "0.5rem",
        },

        "&:hover": {
            backgroundColor: theme.colors.violet[1],
        },
    },
    description: {
        fontSize: rem(16),
        color: theme.colors.gray[7],
    },
}))
